// extracted by mini-css-extract-plugin
module.exports = {"loader":"PageOverlayLoader_loader__UvtES","loaderOuter":"PageOverlayLoader_loaderOuter__VGxEE"};